import { collection, deleteDoc, doc, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebase-config";
import { CircularProgress } from "@mui/material";
// import CloseIcon from '@mui/icons-material/Close';
import DisplayPost from "./DisplayPost";
const Home = () => {
  const[allPost,setAllPost]=useState([])
  const [loading, setLoading] = useState(true);
  const postRef=collection(db,"post")
  const getPosts=async()=>{
    try {
      const data=await getDocs(postRef)
      const filteredData=data.docs.map((doc)=>({
        ...doc.data(),
        id:doc.id,
      }))
      setAllPost(filteredData)
      setLoading(false)
       console.log(filteredData)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(()=>{
    getPosts()
  },[])
  // const handleDelete= async(id)=>{
  //     try {
  //       await deleteDoc(doc(db,"post",id))
  //       setAllPost(allPost.filter(p=>p.id!==id))
  //       // getPosts()
  //       // alert("data deleted")
  //     } catch (error) {
        
  //     }
  // }
  return (
    <section className="w-full mx-auto mt-14">
      <div className="flex flex-col items-center md:mx-40 mx-10 mt-8">
        <h1 className="font-extrabold text-slate-800 text-3xl">The Community Showcase</h1>
        <p className="mt-2 text-slate-600 text-sm">Browse through a collection of imaginative and visually stunning images generated by Stable Diffusion AI</p>
      </div>
      <div className="mt-10">
        {loading?(
           <div className="flex justify-center items-center">
           <CircularProgress sx={{ color: "black" }}/>
         </div>
        ):(
          <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 md:gap-10 gap-5 lg:mx-40 mx-10 mb-10">
              {
                allPost && allPost.map((post)=>{
                  return(
                    <DisplayPost  key={post.id}
                    logo={post.logo}
                    image={post.image}
                    prompt={post.prompt}
                    user={post.user}
                    id={post.id}
                    allPost={allPost}
                    setAllPost={setAllPost}
                    postRef={postRef}/>
                  )
                })
              }
            </div>
        )}
      </div>
      
    </section>
  );
};

export default Home;
